module.exports = __webpack_public_path__ + "img/GreekTechSarissophoroi3_ua.dd8ae717.webp";